import { render, staticRenderFns } from "./googleSearchResults.vue?vue&type=template&id=39b4f2be&scoped=true&"
import script from "./googleSearchResults.vue?vue&type=script&lang=js&"
export * from "./googleSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./googleSearchResults.vue?vue&type=style&index=0&id=39b4f2be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4f2be",
  null
  
)

export default component.exports